import { FEATURE_NAMES } from '../../loaders/features/features';
export var FEATURE_NAME = FEATURE_NAMES.pageViewEvent;